import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { FaStar, FaQuoteLeft, FaArrowLeft, FaArrowRight } from "react-icons/fa";

const TESTIMONIALS = [
  {
    id: 1,
    name: "Mr. Vikas Patil",
    role: "Event Organizer",
    text:
      "Booked Amruta Travels for corporate guest transfers — everything ran perfectly on time. Excellent coordination, GPS tracking, and clean vehicles.",
  },
  {
    id: 2,
    name: "Ms. Neha Joshi",
    role: "Business Consultant",
    text:
      "The Urbania from Amruta Travels is luxury on wheels! Super comfortable seats and smooth driving. A five-star experience!",
  },
  {
    id: 3,
    name: "Mr. Rohit Sharma",
    role: "Corporate Traveller",
    text:
      "Amruta Travels provided a seamless Pune–Mumbai cab experience. The vehicle was spotless, the driver was punctual, and the journey was stress-free!",
  },
  {
    id: 4,
    name: "Ms. Sneha Kulkarni",
    role: "Family Tourist",
    text:
      "We booked Amruta’s Urbania for our Mahabaleshwar trip — super comfortable, clean, and safe. The driver was polite and professional throughout.",
  },
];

export default function TestimonialsAmruta() {
  return (
    <section
      className="testimonials-amruta section-space"
      style={{
        background: "linear-gradient(135deg, #001f3f, #0072bc)",
        color: "#fff",
        position: "relative",
        overflow: "hidden",
        padding: "80px 0",
      }}
    >
      {/* Header Section */}
      <div className="container text-center mb-5">
        <h6 className="text-uppercase" style={{ letterSpacing: "2px" }}>
          Testimonials
        </h6>
        <h2 className="fw-bold mb-3" style={{ color: "#fff" }}>
          What Our Clients Say
        </h2>
        <p style={{ color: "rgba(255,255,255,0.85)" }}>
          Trusted by thousands of travelers for reliable, comfortable, and
          premium cab services.
        </p>
      </div>

      {/* Swiper Section */}
      <div className="container position-relative">
        <Swiper
          modules={[Navigation, Autoplay]}
          autoplay={{ delay: 3500, disableOnInteraction: false }}
          loop
          navigation={{
            nextEl: ".amruta-next",
            prevEl: ".amruta-prev",
          }}
          spaceBetween={30}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1200: { slidesPerView: 3 },
          }}
        >
          {TESTIMONIALS.map((t) => (
            <SwiperSlide key={t.id}>
              <div
                className="testimonial-card"
                style={{
                  background: "#fff",
                  color: "#000",
                  borderRadius: "16px",
                  padding: "30px 24px",
                  boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                  position: "relative",
                  transition: "transform 0.3s, box-shadow 0.3s",
                }}
              >
                {/* Quote icon */}
                <FaQuoteLeft
                  size={36}
                  color="#0072bc"
                  style={{
                    position: "absolute",
                    top: "20px",
                    right: "20px",
                    opacity: 0.1,
                  }}
                />

                {/* Top section */}
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div>
                    <h5 className="fw-bold mb-0">{t.name}</h5>
                    <small className="text-muted">{t.role}</small>
                  </div>
                </div>

                {/* Review text */}
                <p
                  className="mt-3 mb-3"
                  style={{ color: "#333", fontStyle: "italic" }}
                >
                  “ {t.text} ”
                </p>

                {/* Stars */}
                <div style={{ color: "#0072bc" }}>
                  {[...Array(5)].map((_, i) => (
                    <FaStar key={i} />
                  ))}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Navigation arrows */}
        <div
          className="d-flex justify-content-center align-items-center gap-3 mt-4"
          style={{ color: "#fff" }}
        >
          <button
            className="amruta-prev btn"
            style={{
              width: "50px",
              height: "50px",
              borderRadius: "50%",
              background: "#ffffff",
              color: "#0072bc",
              border: "none",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
              transition: "0.3s",
            }}
          >
            <FaArrowLeft />
          </button>
          <button
            className="amruta-next btn"
            style={{
              width: "50px",
              height: "50px",
              borderRadius: "50%",
              background: "#ffffff",
              color: "#0072bc",
              border: "none",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
              transition: "0.3s",
            }}
          >
            <FaArrowRight />
          </button>
        </div>
      </div>
    </section>
  );
}
